export const formatDate = (value, locale = 'en-US') => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const formatTime = (value, locale = 'en-US') => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};

export const formatDateTime = (value, locale = 'en-US') => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  const formattedDate = formatDate(date, locale);
  const formattedTime = formatTime(date, locale);

  if (formattedDate === '-' || formattedTime === '-') return '-';
  return `${formattedDate} ${formattedTime}`;
};
